export enum StorageKeys {
    TOKEN = 'ATO',
    USERID = 'userId',
    USER = 'user'
}